export const pluginPermissions = {
  update: [{
    action: 'plugin::learning-objectives.update',
    subject: null
  }],
  delete: [{
    action: 'plugin::learning-objectives.delete',
    subject: null
  }]
};